<template>
  <div class="course">
    <main-info
      :info="info"
      :statistical="statistical"
    />
    <div class="table-info">
      <div class="table-info-t">
        <tab-info txt="学习员工明细" />
        <export-xlsx :api="api" />
      </div>
      <div class="list-biz-div">
        <list-biz
          class="list"
          :config="params.config"
          :data="params.listData"
          :total="params.total"
          :page="params.page"
          @on-current-change="handleOnCurrentChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import mainInfo from './components/main-info'
import tabInfo from '@components/tab-info'
import exportXlsx from '@components/export-xlsx'
import { MBASVCAPIS } from '@api'
import status from './components/status'
export default {
  components: {
    mainInfo,
    tabInfo,
    exportXlsx
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      info: {},
      statistical: {},
      api: {
        name: MBASVCAPIS.CourseApi.courseExportCourseEmployeePost,
        params: {
          _id: this.$route.query.id,
          page: 1,
          pageSize: 10
        }
      },
      params: {
        listData: [],
        config: {
          mode: 'table',
          list: {
            type: 'table',
            columns: [
              {
                prop: 'employeeName',
                label: '姓名',
                // 自定义组件
                component: null,
                minWidth: '140'
              },
              {
                prop: 'employeeDept',
                label: '部门',
                // 自定义组件
                component: null,
                minWidth: '140'
              },
              {
                prop: 'status',
                label: '状态',
                // 自定义组件
                component: status,
                minWidth: '140'
              },
              {
                prop: 'learnDuration',
                label: '累积学习时长',
                // 自定义组件
                component: null,
                minWidth: '140'
              }
            ]
          }
        },
        total: 0,
        page: 1
      }
    }
  },
  created () {
    let metas = {}
    if (window.departmentIds.length > 0 || window.userIds.length > 0) {
      if (window.departmentIds.length > 0) metas.departmentIds = window.departmentIds
      if (window.userIds.length > 0) metas.userIds = window.userIds
    } else {
      metas.all = true
    }
    this.api.params = {
      ...this.api.params,
      ...metas
    }
    this.init({
      departmentIds: window.departmentIds,
      userIds: window.userIds
    })
  },
  methods: {
    init (data) {
      this.params.page = 1
      this.api.params = {
        ...this.api.params,
        page: 1
      }
      let metas = {}
      if (window.departmentIds.length > 0 || window.userIds.length > 0) {
        metas.departmentIds = window.departmentIds
        metas.userIds = window.userIds
        metas.all = false
      } else {
        metas.departmentIds = []
        metas.userIds = []
        metas.all = true
      }
      this.api.params = {
        ...this.api.params,
        ...metas
      }
      this.courseBriefGet()
      this.courseAnalysisMissionPost(data)
      this.courseAnalysisMissionEmployeePost(data)
    },
    update (params) {
      this.params.page = 1
      this.api.params = {
        ...this.api.params,
        page: 1
      }
      let metas = {}
      if (window.departmentIds.length > 0 || window.userIds.length > 0) {
        metas.departmentIds = window.departmentIds
        metas.userIds = window.userIds
        metas.all = false
      } else {
        metas.all = true
      }
      this.api.params = {
        ...this.api.params,
        ...metas
      }
      this.courseAnalysisMissionPost(params)
      this.courseAnalysisMissionEmployeePost(params)
    },
    handleOnCurrentChange (e) {
      this.params.page = e
      this.api.params = {
        ...this.api.params,
        page: e
      }
      this.courseAnalysisMissionEmployeePost({
        departmentIds: window.departmentIds,
        userIds: window.userIds
      })
    },
    async courseAnalysisMissionEmployeePost (params) {
      let metas = {
        _id: this.$route.query.id,
        page: this.params.page,
        pageSize: 10
      }
      if (params && (params.departmentIds.length > 0 || params.userIds.length > 0)) {
        metas.departmentIds = params.departmentIds
        metas.userIds = params.userIds
        metas.all = false
      } else {
        metas.departmentIds = []
        metas.userIds = []
        metas.all = true
      }
      const { success, data } = await MBASVCAPIS.CourseApi.courseAnalysisCourseEmployeePost(metas)
      if (success) {
        this.params.listData = data.data
        this.params.total = data.total
      }
    },
    async courseAnalysisMissionPost (params) {
      let metas = {}
      if (params && (params.departmentIds.length > 0 || params.userIds.length > 0)) {
        if (params.departmentIds.length > 0) metas.departmentIds = params.departmentIds
        if (params.userIds.length > 0) metas.userIds = params.userIds
        metas.all = false
      } else {
        metas.departmentIds = []
        metas.userIds = []
        metas.all = true
      }
      const { success, data } = await MBASVCAPIS.CourseApi.courseAnalysisCoursePost({
        _id: this.$route.query.id,
        ...metas
      })
      if (success) {
        this.statistical = data
      }
    },
    async courseBriefGet () {
      const { success, data } = await MBASVCAPIS.CourseApi.courseBriefGet({
        _id: this.id
      })
      if (success) {
        this.info = data
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .course {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: calc(100% - 40px);
    margin: 0 auto;

    .table-info {
      display: flex;
      flex-direction: column;
      flex: 1;
      overflow: hidden;

      .table-info-t {
        height: 28px;
        display: flex;
        justify-content: space-between;
        margin: 35px 0 10px 0;
      }

      .list-biz-div {
        flex: 1;
        overflow: hidden;
      }
    }
  }
</style>
